import React from 'react';
import { ShowFormError } from '../forms/FormError';
import { Input } from '../ui/input';
import { PasswordInput } from '../ui/password-input';
import Button from '@/components/ui/button';
import { FormField } from '../forms/FormField';
import { MAIL_TO } from '@/config/app.config';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { LoginPayload } from '@/schemas/login.schema';

interface LoginFormProp {
  errors: FieldErrors<LoginPayload>;
  handleSubmit: (value: any) => any;
  onSubmit: (values: LoginPayload) => void;
  isLoggingIn: boolean;
  register: UseFormRegister<LoginPayload>;
  isValid: boolean;
  isSubmitting: boolean;
}

const LoginForm: React.FC<LoginFormProp> = ({
  errors,
  handleSubmit,
  isLoggingIn,
  onSubmit,
  register,
  isValid,
  isSubmitting,
}) => {
  return (
    <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
      <div className="space-y-4">
        {/* Email */}
        <FormField label="Email" name="email" error={errors.email}>
          <Input
            {...register('email')}
            type="email"
            placeholder="Enter your email"
            autoComplete="email"
            error={!!errors.email}
          />
        </FormField>

        {/* Password */}
        <FormField label="Password" name="password" error={errors?.password}>
          <PasswordInput
            {...register('password')}
            autoComplete="current-password"
            error={!!errors.password}
            placeholder="Enter your password"
          />
        </FormField>
        <div className="text-right">
          <a
            href="/forgot-password"
            className="text-sm text-primary-600 hover:text-primary-500 font-medium"
          >
            Forgot password?
          </a>
        </div>
      </div>

      <ShowFormError message={errors.root?.message} className="bg-red-50 border border-red" />

      <Button
        className="w-full"
        variant="primary"
        size="md"
        disabled={!isValid || isSubmitting}
        isLoading={isLoggingIn}
        type="submit"
      >
        Sign In
      </Button>

      {/* Sign Up link */}
      <div className="text-center">
        <p className="text-sm text-gray-600">
          Don’t have an account?{' '}
          <a href="/signup" className="font-medium text-primary-600 hover:text-primary-500">
            Sign up
          </a>
        </p>
      </div>

      <div className="text-center">
        <p className="text-sm text-gray-600">
          Need help?{' '}
          <a href={MAIL_TO} className="font-medium text-primary-600 hover:text-primary-500">
            Contact support
          </a>
        </p>
      </div>
    </form>
  );
};

export default LoginForm;
